import {Injectable} from '@angular/core';
import {interval} from 'rxjs';
import {messageData} from '../datas/message';

export class MessageModel {
  SUCCESS: string;
  ERROR: string;
  TITLE: string;
  DESCRIPTION: string;
  WAIT_DESCRIPTION: string;
  MESSAGE: string;
}

@Injectable()
export class MessageService {
  private message: MessageModel;

  getMessage(process) {
    if (process == 'create') {
      return this.messageCreate();
    } else if (process == 'update') {
      return this.messageUpdate();
    } else if (process == 'delete') {
      return this.messageDelete();
    } else {
      return null;
    }
  }

  private messageCreate() {
    this.message = {
      SUCCESS: messageData.DATA.SAVE.SUCCESS,
      ERROR: messageData.DATA.SAVE.ERROR,
      TITLE: messageData.DATA.SAVE_CONFIRM.TITLE,
      DESCRIPTION: messageData.DATA.SAVE_CONFIRM.DESCRIPTION,
      WAIT_DESCRIPTION: messageData.DATA.SAVE_CONFIRM.WAIT_DESCRIPTION,
      MESSAGE: messageData.DATA.SAVE_CONFIRM.MESSAGE,
    };

    return this.message;
  }

  private messageUpdate() {
    this.message = {
      SUCCESS: messageData.DATA.UPDATE.SUCCESS,
      ERROR: messageData.DATA.UPDATE.ERROR,
      TITLE: messageData.DATA.UPDATE_CONFIRM.TITLE,
      DESCRIPTION: messageData.DATA.UPDATE_CONFIRM.DESCRIPTION,
      WAIT_DESCRIPTION: messageData.DATA.UPDATE_CONFIRM.WAIT_DESCRIPTION,
      MESSAGE: messageData.DATA.UPDATE_CONFIRM.MESSAGE,
    };

    return this.message;
  }

  private messageDelete() {
    this.message = {
      SUCCESS: messageData.DATA.DELETE.SUCCESS,
      ERROR: messageData.DATA.DELETE.ERROR,
      TITLE: messageData.DATA.DELETE_CONFIRM.TITLE,
      DESCRIPTION: messageData.DATA.DELETE_CONFIRM.DESCRIPTION,
      WAIT_DESCRIPTION: messageData.DATA.DELETE_CONFIRM.WAIT_DESCRIPTION,
      MESSAGE: messageData.DATA.DELETE_CONFIRM.MESSAGE,
    };

    return this.message;
  }

  private messageActivate() {
    this.message = {
    SUCCESS: messageData.DATA.ACTIVATE.SUCCESS,
      ERROR: messageData.DATA.ACTIVATE.ERROR,
      TITLE: messageData.DATA.ACTIVATE_CONFIRM.TITLE,
      DESCRIPTION: messageData.DATA.ACTIVATE_CONFIRM.DESCRIPTION,
      WAIT_DESCRIPTION: messageData.DATA.ACTIVATE_CONFIRM.WAIT_DESCRIPTION,
      MESSAGE: messageData.DATA.ACTIVATE_CONFIRM.MESSAGE,
    };

    return this.message;
  }
}
